import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { ZeroCapaMethod } from './components/ZeroCapaMethod';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { PriceBlock } from './components/PriceBlock';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans antialiased selection:bg-sage-light selection:text-sage-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedSolutions data-id="element-3" />
      <ZeroCapaMethod data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <PriceBlock data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}